import { render } from "./documentation.vue?vue&type=template&id=3584b46a"
import script from "./documentation.vue?vue&type=script&lang=ts"
export * from "./documentation.vue?vue&type=script&lang=ts"
script.render = render

export default script